import { DebinMovement, Recurrence } from 'store/debin/types'
import { instance } from '.'
import { insertKeyEndpoint } from './utils'

interface Response<T> {
  message: string
  data: T
  error: boolean
}

interface ConfirmRecurrenceParams {
  recurrenceId: number
  isAccepted: boolean
}

export interface CancelRecurrenceResponse {
  recurrence: Recurrence,
  isRefund: boolean
}

export const getRecurrences = async () => {
  return instance.get<Response<Recurrence[]>>(
    insertKeyEndpoint('debin/recurrence')
  )
}

export const confirmRecurrence = async ({
  recurrenceId,
  isAccepted
}: ConfirmRecurrenceParams) => {
  return instance.post<Response<Recurrence>>(
    insertKeyEndpoint(`debin/recurrence/${recurrenceId}`),
    {
      isAccepted
    }
  )
}

export const cancelRecurrence = async (recurrenceId: number) => {
  return instance.post<Response<CancelRecurrenceResponse>>(
    insertKeyEndpoint(`debin/recurrence/cancel/${recurrenceId}`)
  )
}

export const getDebinMovements = async () => {
  return instance.get<Response<DebinMovement[]>>(
    insertKeyEndpoint('debin/debin-movements')
  )
}
